import PropTypes from 'prop-types';

export const DefaultProps = {
  clients: [],
};

export const Props = {
  clients: PropTypes.arrayOf(PropTypes.object),
};
